import o from "../packages/web-components/src/utils/data/states.json.js";
import a from "../packages/web-components/src/utils/data/countries.json.js";
function m() {
  return a.map(function (t) {
    return {
      value: t.iso2,
      label: t.name
    };
  });
}
function i(e) {
  var t = o;
  return t = t.filter(function (r) {
    return r.country_code === e;
  }), t.map(function (r) {
    return {
      value: r.name,
      label: r.name
    };
  });
}
export { m as formattedCountriesForDropdown, i as formattedStatesForDropdown };